import { isFeedbackMenu } from 'organisms/NavBar/FeedbackSubMenu'
import { isTeamMembersMenu } from 'organisms/NavBar/TeamMembersSubMenu'

/**
 * Returns true when the given pathname renders a left-side submenu in the
 * global NavBar. Used to gate the PageHeader's submenu-toggle icon and as
 * the source of truth for NavBar's submenu visibility on route changes.
 */
export function hasSubMenuRouting(pathname: string): boolean {
  if (pathname.includes('/dashboards/')) {
    return true
  }
  if (pathname.includes('/profile/')) {
    return true
  }
  if (pathname.includes('/reports/')) {
    return true
  }
  if (pathname.includes('/settings/') && !pathname.includes('/settings/integrations/')) {
    return true
  }
  if (isFeedbackMenu(pathname)) {
    return true
  }
  if (isTeamMembersMenu(pathname)) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/shared/utils/hasSubMenuRouting/index.ts